import _ from "lodash";
import { store } from "store/createStore";
import { getIsLearningCoursesEnabled } from "LearningCourses/modules/Utils";

//Lower number means higher priority in hierarchy
const CONTEXT_ENTITY_TYPE_ORDER_MAP = {
  COURSE: 10,
  LEARNING_COURSE: 20,
  GRADE: 30,
  CURRICULUM_PROGRAM: 40,
  ORGANIZATION: 50,
};

//Explicity extracting values from state instead of using selectors to avoid any circular dependency issues now/in future
const getEntityIdByContextLevel = level => {
  const state = store.getState();
  switch (level) {
    case "COURSE":
      return _.get(state, "teacher.selected_class.selected_course", undefined);
    case "LEARNING_COURSE":
      return _.get(
        state,
        "learningCourse.selectedLearningCourse.id",
        undefined
      );
    case "GRADE": {
      return getIsLearningCoursesEnabled()
        ? _.get(
            state,
            "learningCourse.selectedLearningCourse.primaryGradeId",
            undefined
          )
        : _.get(state, "teacher.selected_class.primaryGrade.id", undefined);
    }
    case "CURRICULUM_PROGRAM":
      return _.get(state, "platform.currentCurriculumProgram.id", undefined);
    default:
      return null;
  }
};

// Use this util to generate contexts for required level while reading/fetching value by passing explicit contexts
const generateRnPContextsByLevel = ({
  level = "COURSE",
  curriculumProgramId = null,
  gradeId = null, // primary gradeId
  learningCourseId = null,
  courseId = null,
}) => {
  const contexts = [];
  const levelOrder = CONTEXT_ENTITY_TYPE_ORDER_MAP[level];

  // Add entities based on hierarchy order
  if (levelOrder <= CONTEXT_ENTITY_TYPE_ORDER_MAP.COURSE) {
    contexts.push({
      entityId: courseId || getEntityIdByContextLevel("COURSE"),
      entityType: "COURSE",
    });
  }

  if (
    levelOrder <= CONTEXT_ENTITY_TYPE_ORDER_MAP.LEARNING_COURSE &&
    getIsLearningCoursesEnabled()
  ) {
    contexts.push({
      entityId:
        learningCourseId || getEntityIdByContextLevel("LEARNING_COURSE"),
      entityType: "LEARNING_COURSE",
    });
  }

  if (levelOrder <= CONTEXT_ENTITY_TYPE_ORDER_MAP.CURRICULUM_PROGRAM) {
    contexts.push({
      entityId:
        curriculumProgramId || getEntityIdByContextLevel("CURRICULUM_PROGRAM"),
      entityType: "CURRICULUM_PROGRAM",
    });
  }

  return [_.uniqBy(contexts, ({ entityType }) => entityType)];
};

export { CONTEXT_ENTITY_TYPE_ORDER_MAP, generateRnPContextsByLevel };
